import { Card } from "antd";
import React from "react";
import { formatUAHStandard } from "tm-shared/utils";

import { PrimaryText } from "@/shared/ui/Typography";

import {
    StyledDebtCardSection,
    StyledDebtCardSectionBottom,
    StyledDebtCardSectionTop,
    StyledDebtLabel,
    StyledDebtValue,
} from "./Styled";

interface DebtCardProps {
    shipmentDate: string;
    paymentDate: string;
    paymentForm: string;
    amount: number;
    debt: number;
    overdueDays: string;
    consignmentId?: string;
}

const DebtCard: React.FC<DebtCardProps> = ({
    debt,
    overdueDays,
    amount,
    paymentForm,
    paymentDate,
    shipmentDate,
    consignmentId,
}) => (
    <Card>
        {consignmentId && (
            <StyledDebtCardSectionTop>
                <PrimaryText fontWeight="bold">{consignmentId}</PrimaryText>
            </StyledDebtCardSectionTop>
        )}

        <StyledDebtCardSectionTop>
            <StyledDebtLabel>Дата доставки</StyledDebtLabel>
            <StyledDebtValue>{shipmentDate || "-"}</StyledDebtValue>
        </StyledDebtCardSectionTop>

        <StyledDebtCardSection>
            <StyledDebtLabel>Дата оплати</StyledDebtLabel>
            <StyledDebtValue>{paymentDate}</StyledDebtValue>
        </StyledDebtCardSection>

        <StyledDebtCardSection>
            <StyledDebtLabel>Форма оплати</StyledDebtLabel>
            <StyledDebtValue>{paymentForm}</StyledDebtValue>
        </StyledDebtCardSection>

        <StyledDebtCardSection>
            <StyledDebtLabel>Сума</StyledDebtLabel>
            <StyledDebtValue>{formatUAHStandard(amount)}</StyledDebtValue>
        </StyledDebtCardSection>

        <StyledDebtCardSection>
            <StyledDebtLabel $isDanger>Борг</StyledDebtLabel>
            <StyledDebtValue $isDanger>
                {formatUAHStandard(debt)}
            </StyledDebtValue>
        </StyledDebtCardSection>

        <StyledDebtCardSectionBottom>
            <StyledDebtLabel $isDanger>Прострочено днів</StyledDebtLabel>
            <StyledDebtValue $isDanger>{overdueDays}</StyledDebtValue>
        </StyledDebtCardSectionBottom>
    </Card>
);

export default React.memo(DebtCard);
